import React from 'react'

import { Form, Col } from '_zari/core'

const FechaDesdeFormGroup = ({ value, onChange }) => {
  return (
    <Form.Group>
      <Form.Label text='FECHA DESDE' htmlFor='input-fechaDesde' md={4} />
      <Col md={8}>
        <Form.InputDate 
        name="inputFecha"
        value={value} onChange={onChange} id='input-fechaDesde' />
      </Col>
    </Form.Group>
  )
}

export default FechaDesdeFormGroup
